/**
 * /signalen — systeemsignalen die kantoor moet afhandelen.
 *
 * De tegenhanger van /telefoon → Opvolgen. Beide lezen `/api/tasks`, maar op
 * een andere `kind`: telefoonwerk (voicemail, gemiste oproep) blijft bij de
 * telefoon, al het andere (convert, doorverwijs, financieel, comms) komt hier.
 * Vóór deze splitsing stond het door elkaar in één lijst, met een taak over
 * factuurprijzen onder de kop "Onbekend nummer" (vondst 07-08).
 *
 * De scheiding zelf zit op de server (TELEFONIE_SOURCES in api/_lib/tasks.ts).
 * Deze pagina kent geen bronnenlijst — die zou meteen afdrijven.
 *
 * Rollen: admin + medewerker. Bewust niet callcenter: dit is geen belwerk.
 */

import { useState } from 'react';
import { TakenList } from '../components/phone/TakenList';

export function SignalenPage() {
  const [openCount, setOpenCount] = useState<number | null>(null);

  return (
    <div className="h-full overflow-y-auto p-6 max-w-[1400px] mx-auto">
      <div className="flex items-baseline gap-3 mb-1">
        <h1 className="text-2xl font-heading font-semibold text-main">Signalen</h1>
        {openCount !== null && openCount > 0 && (
          <span className="text-sm text-slate-500">{openCount} open</span>
        )}
      </div>
      <p className="text-sm text-slate-500 mb-6">
        Meldingen uit de systemen die iemand moet oppakken: conversies die niet liepen,
        partners die niet reageren, prijzen die nagerekend moeten worden. Terugbellen na
        een voicemail staat bij Telefoon.
      </p>

      <TakenList kind="systeem" onCountChange={setOpenCount} />
    </div>
  );
}
